import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function ComposeMessage() {
    const [messview, setMessView] = useState([]);
    const [user, setUser] = useState([]);
    const [messageData, setmessageData] = useState({
        "department": '',
        "username": '',
        "subject": '',
        "message": '',
        "file_type": '',
        "attachment": '',
        "open_status": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
        "f_files": null, // Add the f_files property with an initial value of null
    });
    useEffect(() => {
        fetchData();
    }, []);
    function fetchData() {
        axios.get(baseUrl + "user-search/")
            .then(response => {
                setUser(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    useEffect(() => {
        fetchmessData();
    }, []);
    function fetchmessData() {
        axios.get(baseUrl + "view-mess/" + userName)
            .then(response => {
                setMessView(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleMessChange = (event) => {
        setmessageData({
            ...messageData,
            [event.target.name]: event.target.value
        });
    }
    const handleFileChange = (event) => {
        setmessageData({
            ...messageData,
            f_files: event.target.files[0], // Update the f_files property with the selected file
        });
    };
    const formSubmitmed = (e) => {
        e.preventDefault();
        const _formData = new FormData();
        const file_type = document.getElementById("ftype").value;
        const username = document.getElementById("username").value;
        if (messageData.f_files) {
            _formData.append('file_type', file_type);
            _formData.append('attachment', messageData.f_files, messageData.f_files.name);
        }
        _formData.append('username', messageData.username);
        _formData.append('subject', messageData.subject);
        _formData.append('message', messageData.message);
        _formData.append('open_status', '0');
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        axios.post(`${baseUrl}mess-create/`, _formData)
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'Message Sent.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setmessageData({
                        appt_id: '',
                        file_type: '',
                        files: '',
                        comments: '',
                        file_date: '',
                        status: '',
                        addedby: '',
                        ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = '/comp-mess/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to Send Message. Please try again later.',
                    'error'
                );
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-mess/' + id)
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-comment"
                aria-hidden="true" style={{color: 'red'}}></i> Compose Message</h3>
            <div className="row mt-4">
                <form>
                    <div className="table-responsive">
                        <table className="erp-table-modern">
                            <tbody>

                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <td>User :</td>
                                <td>
                                    <select className="form-control" value={messageData.username}
                                            onChange={handleMessChange}
                                            name="username" id="username">
                                        <option value="">Select User</option>
                                        {user.map((department, index) => {
                                            return <option key={index} value={department.username}>{department.username}
                                            </option>
                                        })}
                                    </select>
                                </td>
                            </tr>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <td>Subject :</td>
                                <td>
                                    <input type="text" className="no-comma" name="subject" id="subject"
                                           value={messageData.subject}
                                           onChange={handleMessChange}/>
                                </td>
                            </tr>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <td>Message :</td>
                                <td>
             <textarea className="no-comma" tabIndex="0" name="message" id="message"
                       value={messageData.message}
                       onChange={handleMessChange}>
             </textarea>
                                </td>
                            </tr>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <td>Type of File :</td>
                                <td>
                                    <select name="ftype" id="ftype" value={messageData.ftype}
                                            onChange={handleMessChange}>
                                        <option value=""></option>
                                        <option value="ctscan">CT-Scan</option>
                                        <option value="xray">X-Ray</option>
                                        <option value="casesheet">Case Sheet</option>
                                        <option value="other">Other Docs</option>
                                    </select>
                                </td>
                            </tr>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <td>File Upload :</td>
                                <td>
                                    <input type="file" className="form-control" name="f_files"
                                           onChange={handleFileChange} id="f_files"/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <button type="button" onClick={formSubmitmed} className="btn btn-primary mt-4">Submit</button>
                </form>
            </div>
            <div className="row mt-4">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-list" aria-hidden="true" style={{color: 'red'}}></i>
                    View Message
                </h3>
                <div className="table-responsive">
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th>From</th>
                            <th>To</th>
                            <th>Subject</th>
                            <th>Message</th>
                            <th>File Type</th>
                            <th>File</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {messview.map((messviewData, index) => (
                            <tr>
                                <td>{messviewData.addedby}</td>
                                <td>{messviewData.username}</td>
                                <td>{messviewData.subject}</td>
                                <td>{messviewData.message}</td>
                                <td>{messviewData.file_type}</td>
                                <td>
                                    <div>
                                        <iframe
                                            src={messviewData.attachment}
                                            title={messviewData.attachment}
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </td>
                                <td>
                                    {messviewData.addedby === userName && (
                                        <button
                                            onClick={() => handleDelete(messviewData.id)}
                                            className="btn btn-danger btn-sm ms-1"
                                        >
                                            <i className="fa-solid fa-trash-can"></i>
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className='col-md-12 col-12 mb-2 mt-5'>
                        <div className="conversation-box">
                            {messview.map((messviewData, index) => (
                                <div className="message-container">
                                    <div className="message incoming">
                                        <h4>{messviewData.subject}</h4>
                                        <p>{messviewData.message}</p>
                                        <h5>{messviewData.add_date}</h5>
                                    </div>
                                    <div className="message outgoing">
                                        <h4>{messviewData.subject}</h4>
                                        <p>{messviewData.message}</p>
                                        <h5>{messviewData.add_date}</h5>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default ComposeMessage;
